import React from 'react'

// components
import {
  CCol,
  CRow,
  CButton,
  CCard,
  CBadge
} from '@coreui/react-pro'
import { cilFile } from '@coreui/icons'
import FormSelectInput from './FormSelectInput'

// icons
import CIcon from '@coreui/icons-react'

// styling
import { styleButtonVars1 } from 'src/components/custom-styles/buttonStyles'

// helper
import { getFileType } from 'src/helpers/get-file-type';

const FormFileThumbnail = ({
  name,
  colSize,
  className,
  files,
  handleConfirmDelete,
  isDetailPage = false,
  handleViewFile,
  isShowDropdown = false,
  inputDropdownLabel,
  dropdownPlaceholder,
  dropdownName,
  selectOptions,
  handleShowModal,
  indexParent,
}) => {
  return (
    <CRow className={className}>
        {
          files.map((file, index) => {
            let valueDropdown = null
            let isFile = false
            if (name === 'project_contracts') {
              if (file instanceof File) {
                isFile = true
              }
              if (file?.is_signed !== null) {
                if (file?.is_signed) {
                  valueDropdown = {
                    label: 'Signed',
                    value: true
                  }
                } else {
                  valueDropdown = {
                    label: 'Not signed',
                    value: false
                  }
                } 
              }
            }

            let fileName = file?.attachment_url ? file?.attachment_original_name : file?.file_url ? file?.file_original_name : file?.name
            let fileType = getFileType(fileName)
            return (
              <CCol lg={colSize} className='mb-3'>
                <CCard key={index} className='justify-contet-center align-items-center p-3 p-lg-2 p-xxl-3'>
                  <CIcon icon={cilFile} size='6xl'/>
                  {
                    isDetailPage && name == 'project_contracts' && (
                      <div>
                        {
                          file?.is_signed ? (
                            <CBadge color="success">Signed</CBadge>
                          ) : (
                            <CBadge color='secondary' textBgColor="light">Not signed</CBadge>                            
                          )
                        }
                      </div>
                    )
                  }
                  <span 
                    className='my-2 text-center px-2' 
                    style={{
                      wordBreak: 'break-word',
                      overflowWrap: 'break-word',
                      width: '100%',
                      display: 'block'
                    }}
                  >{fileName}</span>
                  {
                    !isDetailPage ? (
                      <CRow className='w-100'>
                        <CCol lg={12} xl={6} className='mb-2'>
                          {
                            file instanceof File ? fileType !== 'docs' ? (
                              <CButton
                                style={styleButtonVars1}
                                size="sm"
                                className='w-100'
                                onClick={() => handleViewFile(file)}
                              >
                                View
                              </CButton>
                            ) : null : (
                              <CButton
                                style={styleButtonVars1}
                                size="sm"
                                className='w-100'
                                onClick={() => handleViewFile(file?.attachment_url ? file?.attachment_url : file?.file_url)}
                              >
                                View
                              </CButton>
                            )
                          }
                        </CCol>
                        <CCol lg={12} xl={file instanceof File ? fileType !== 'docs' ? 6 : 12 : 6}>
                          <CButton
                            style={styleButtonVars1}
                            size="sm"
                            className='w-100'
                            onClick={() => handleConfirmDelete({ show: true, type: name, item: file, index: indexParent ? indexParent : index })}
                          >
                            Remove
                          </CButton>
                        </CCol>
                      </CRow>
                    )
                    :  (
                      <CRow className='w-100'>
                        <CCol lg={12} xl={6} className='mb-2'>
                          <CButton
                            style={styleButtonVars1}
                            size="sm"
                            className='w-100'
                            onClick={() => handleViewFile(file?.attachment_url ? file?.attachment_url : file?.file_url)}
                          >
                            View
                          </CButton>
                        </CCol>
                        <CCol lg={12} xl={6}>
                          <CButton
                            style={styleButtonVars1}
                            size="sm"
                            as='a'
                            className='w-100'
                            href={file.attachment_url ? file?.attachment_url : file.file_url}
                            target='_blank'
                          >
                            Download
                          </CButton>
                        </CCol>
                      </CRow>
                    )
                  }
                  {
                    isShowDropdown && !isFile && (
                      <FormSelectInput
                        name={dropdownName}
                        colSize='12'
                        inputLabel={inputDropdownLabel}
                        className='my-3'
                        selectOptions={selectOptions}
                        value={valueDropdown}
                        handleSelectInput={(e) => handleShowModal({ show: true, item: file, value: e })}
                        disabled={false}
                        multiple={false}
                        placeholder={dropdownPlaceholder}
                      />
                    )
                  }
                </CCard>
              </CCol>
            )
          })
        }
    </CRow>
  )
}

export default FormFileThumbnail